import * as propertyTypes from "../property_types.js"

export class UiLabelProps extends propertyTypes.AppBaseComponentProps {

    private isUrlMetadata = new propertyTypes.TextProperty("isUrl", "Is url");
    public isUrl: string;

    private urlTemplateMetadata = new propertyTypes.TextProperty("urlTemplate", "Url template");
    public urlTemplate: string;

    private textTemplateMetadata = new propertyTypes.TextProperty("textTemplate", "Text template");
    public textTemplate: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.isUrlMetadata, this.urlTemplateMetadata, this.textTemplateMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}